<template>
<svg class="custom-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
        <path d="M28.962,15.309c-0.025-0.062-0.062-0.117-0.109-0.163l-3.999-3.999c-0.195-0.195-0.512-0.195-0.707,0
            s-0.195,0.512,0,0.707L27.293,15H9c-0.276,0-0.5,0.224-0.5,0.5S8.724,16,9,16h18.293l-3.146,3.146
            c-0.195,0.195-0.195,0.512,0,0.707C24.244,19.951,24.372,20,24.5,20s0.256-0.049,0.354-0.146l3.999-3.999
            c0.046-0.046,0.083-0.102,0.109-0.163C29.012,15.569,29.012,15.431,28.962,15.309z" />
        <path d="M7.5,15.5C7.5,14.673,8.173,14,9,14h11V3.5C20,2.122,18.879,1,17.5,1h-15C1.122,1,0,2.122,0,3.5v24
            C0,28.879,1.122,30,2.5,30h15c1.379,0,2.5-1.121,2.5-2.5V17H9C8.173,17,7.5,16.327,7.5,15.5z" />
    </svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
